import { Component, OnInit } from '@angular/core';
import { GatewayStatusService } from './gateway-status.service';

@Component({
  selector: 'app-gateway-status',
  templateUrl: './gateway-status.component.html',
  styleUrls: ['./gateway-status.component.scss']
})
export class GatewayStatusComponent implements OnInit {
  
  title = 'Gateway Health'; 

  locationId: string;
  p = 1;

  key = 'gateway_id';
  reverse = true;
  public gateways: any;
  locations: any;
  term = '';

  constructor(private gatewayStatusService: GatewayStatusService) {
  }

  ngOnInit() {
    this.gateways = [];
    this.getGateways();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  private getGateways() {

    this.gatewayStatusService.getGateways()
      .then(result => {

        result.forEach(gateway => {
          gateway.status = this.getStatus(gateway.last_seen);
          this.gateways.push(gateway);
        });

        this.getLocations();
      })
  }

  getLocations(): any {

    this.gatewayStatusService.getLocations()
    .then( result => {
        this.locations = result;

        this.gateways.forEach(gateway => {

          const foundLocation = this.locations.find(x => x.app_id === gateway.app_id);

          if (foundLocation) {
            gateway.location_name = foundLocation.location_name;
            gateway.location_id = foundLocation.location_id;
          } else {
            gateway.location_name = 'Location not found';
          }

      });

    });
  }

  private getStatus(lastSeen: number): string {

    if (lastSeen < (Date.now() - (1000 * 60 * 30))) {
      return 'Offline';
    }
    return 'Online';
  }

  public getCellColor(warningLevel: string): string {
    let color;
    switch (warningLevel) {
      case 'Online': {
        color = 'green';
        break;
      }
      case 'Offline': {
        color = 'orange';
        break;
      }
      case 'Never Seen': {
        color = 'red';
        break;
      }
      case 'Name not found': {
        color = 'red';
        break;
      }
      case 'Location not found': {
        color = 'red';
        break;
      }
      default: {
        color = 'black';
        break;
      }
    }

    return color;

  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-status/gateway-status.component.ts